<script setup>
import { ref, defineProps } from "vue";
import AgeSwitch from "@/components/jaw/AgeSwitch.vue";
import Scheme from "@/components/jaw/Scheme.vue";
import ServiceSelector from "@/components/jaw/ServiceSelector.vue";

defineProps({
  title: {
    type: String,
    required: false,
    default: "Точно знаете что вас беспокоит?",
  },
  subtitle: {
    type: String,
    required: false,
    default: "На наглядной схеме вы можете указать зуб, который вас беспокоит, и выбрать необходимые услуги",
  }
});

const selectedJawType = ref('adult');
const selectedTooth = ref(0);
</script>

<template>
  <section class="relative">
    <div class="container">
      <div class="grid grid-cols-1">
        <div class="max-w-[650px] mx-auto text-center">
          <h2 class="md:text-[38px] text-[34px] font-semibold z-10 relative leading-[48px] md:leading-[53px]">
            {{ title }}
          </h2>
          <p class="text-muted max-w-[500px] mt-4 mx-auto">
            {{ subtitle }}
          </p>
        </div>
      </div>

      <age-switch v-model="selectedJawType" />

      <div class="grid md:grid-cols-2 grid-cols-1 gap-6 mt-3 max-w-[650px] mx-auto">
        <div>
          <scheme
            v-model="selectedTooth"
            :jaw-type="selectedJawType"
          />
        </div>
        <div v-if="selectedTooth">
          <service-selector
            :tooth="selectedTooth"
          />
        </div>
        <div
          v-else
          class="grid content-center text-center"
        >
          <p>Укажите на схеме зуб, который вас беспокоит.</p>
        </div>
      </div>
    </div>
  </section>
</template>
